import React from "react";
import { Button, Spacing } from "@sicredi/react";
import { Link } from "#/components/Link";

type Props = {
  backUrl: string;
};

export const BackButton: React.FC<Props> = ({ backUrl }) => {
  return (
    <div className="hide-mobile">
      <Spacing appearance="medium" />
      <Button as={Link} to={backUrl} appearance="primary" ghost block>
        Voltar
      </Button>
    </div>
  );
};

export default BackButton;
